import React from 'react';
import { connect } from 'react-redux';
import { setDialogs } from '../../../actions';
import { getHost, ACCOUNT } from '../../../const';
import { getSchemeHeader } from '../../../lib/util/utils';
import { clearMainAccount } from '../../../lib/kbApp/kbJsBridgePromise';
import { loginAction, setWelfareAnimation } from '../../../rootStore';
import { detector } from '../../../lib/util/Detect.js';
import './index.scss';

class ActionFalseDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.from = this.props.from;
    this.Log = this.props.Log;
  }

  componentDidMount() {
    switch (this.from) {
      case 'exchange':
        this.Log && this.Log.sendExposure({
          element_type: 'exchange',
                	element_name: 'exchange_popup_fail',
        });
        break;
      default:
        break;
    }
  }

	close = () => {
	  this.props.dialogs.pop();
	  this.props.dispatch(setDialogs(this.props.dialogs));
	  // 设置动画
	  setWelfareAnimation();
	}

	// 跳转到旧版邀请详情页
	toInviteFriend = () => {
	  const url = `${getHost()}/welfare/inviteFriend?refer=welfare_new`;
	  window.location.href = `${getSchemeHeader()}://webview?url=${encodeURIComponent(url)}&innerfrom=welfare_new`;

	  this.close();
	}

	// 切换账号
	transAccount = () => {
	  const loginInfo = {
	    type: 'qqorweixin',
	    resetLoginWording: '1',
	    wording1: '推荐使用微信或者QQ登录',
	    wording2: '记住你的阅读兴趣',
	    showDialogLogin: '1',
	    from: 'fuli_center',
	  };
	  const { credit } = this.props;
	  const { mainAccount } = this.props.kbApp;
	  if (mainAccount === 'other' || credit === ACCOUNT.STATUS.TINAYU_BLACK) {
	    // 手机登录 or 天域高风险
	    loginInfo.wording1 = '需要用QQ或微信登录才可参与活动';
	    loginInfo.wording2 = '该帐号将成为您的唯一积分帐号';
	  } else if (credit === ACCOUNT.STATUS.NOT_MATCH_DEVICE) {
	    loginInfo.wording1 = '很抱歉，设备已经绑定别的账号';
    		loginInfo.wording2 = '需要登录绑定账号才可以参与活动';
	  }

	  if (detector.app.kuaibao) {  // 快报需要先退出登录
	    clearMainAccount();
	  }

	  loginAction(loginInfo).then(() => {
	    this.props.dispatch(setDialogs([])); // 清空弹窗
	    // 设置动画
	    setWelfareAnimation();
	  });
	}

	render() {
	  const { title, subTitle, from, type } = this.props;

	  return (
			<div className="actionFalseDialog">
				<div className="dialog">
					<div className="close" onClick={this.close} log-click-eltype="cancel"></div>
					<div className="chahua"></div>
					<div className="fail">{title}</div>
					<div className="failTip">{subTitle}</div>
					{from === 'inviteCode'
						&& <div className="btn" onClick={() => this.toInviteFriend()} log-click-eltype="confirm">邀请好友赚现金</div>
					}
					{from === 'transAccount' && detector.app.kuaibao
						&& <div className="btn" onClick={() => this.transAccount()}>立即切换</div>
					}
					{from === 'transAccount' && detector.app.qb
						&& <div className="btn" onClick={() => this.close()}>我知道了</div>
					}
					{type === 'login'
						&& <div className="btn" onClick={() => this.transAccount()}>去登录</div>
					}
				</div>
			</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, preProcess, credit, myIntegral, kbApp } = state;
  return {
    dialogs,
    preProcess,
    credit,
    myIntegral,
    kbApp,
  };
};

export default connect(mapStateToProps)(ActionFalseDialog);
